//import "@fortawesome/fontawesome-pro"
import "@fortawesome/fontawesome-pro/scss/fontawesome.scss"
import "@fortawesome/fontawesome-pro/scss/light.scss"
import "@fortawesome/fontawesome-pro/scss/solid.scss"
import "@fortawesome/fontawesome-pro/scss/brands.scss"
import "./src/assets/scss/main.scss"
import "./src/assets/js/main.js"
